export enum SessionEventType {
  NEW_SESSION = 'NEW_SESSION',
  SESSION_EXISTS = 'SESSION_EXISTS',
  SESSION_REACTIVATED = 'SESSION_REACTIVATED'
}

export interface SessionEvent {
  type: SessionEventType;
  sessionId: string;
}